module.exports = __webpack_public_path__ + "img/arrow_white.2cf0d3f1.svg";